import { DateTimePicker, Input, Radio } from '@smartgift/frontend-toolkit';

import { formatDate } from '@hero/utils';

import * as S from './style';

export function NotificationForm({ formData, formStyle, formik }) {
  const onChange = (name, value) => {
    formik.setFieldValue(name, value);
  };

  const inputs = {
    text: ({ title, ...data }) => (
      <S.NotificationFormInput key={data.name}>
        {title}
        <Input
          key={data?.name}
          variant="outlined"
          {...data}
          helperText={
            (data?.helperTextWithValue &&
              data.helperTextWithValue(
                formik.values[data?.name]?.length || data?.defaultValue?.length || 0
              )) ||
            data?.helperText
          }
          inputProps={{ maxLength: data.maxLength }}
          value={formik.values[data?.name] || data?.defaultValue || ''}
          onChange={e => onChange(data?.name, e.target.value)}
          block
        />
      </S.NotificationFormInput>
    ),
    radio: data => (
      <S.NotificationFormInput key={data.name}>
        {data?.title}
        <S.NotificationFormInputOptions>
          {data.options.map(option => (
            <Radio
              key={option?.value}
              {...option}
              id={option.value}
              checked={formik.values[data?.name] === option.value.toString()}
              onChange={e => {
                onChange(data?.name, e.target.value);
              }}
            />
          ))}
        </S.NotificationFormInputOptions>
      </S.NotificationFormInput>
    ),
    date: data => renderDatePicker(data, value => onChange(data?.name, value))
  };

  return (
    <S.NotificationForm style={formStyle}>
      {formData.map((data, index) => {
        const { type } = data;
        const input = inputs[type];
        return input(data, index);
      })}
    </S.NotificationForm>
  );
}

const renderDatePicker = (inputData, onChange) => {
  const { initialValue = '', placeholder, format, ...rest } = inputData;

  return (
    <DateTimePicker
      placeholder={placeholder}
      defaultValue={initialValue || ''}
      formItem={inputData}
      onChange={date => onChange(format ? formatDate(date, format) : date)}
      {...rest}
      popperPlacement="top"
    />
  );
};
